import { Builder } from '@builder.io/react';
import theme from '../../utilities/brandTheme';
import InlineEmailSignup from './inlineEmailSignup';

Builder.registerComponent(InlineEmailSignup, {
  name: 'InlineEmailSignup',
  inputs: [
    {
      name: 'heading',
      type: 'string',
      required: false,
      defaultValue: 'Subscribe to our newsletter',
      friendlyName: 'Heading',
    },
    {
      name: 'subtext',
      type: 'string',
      required: false,
      defaultValue: 'Stay updated with our latest news and offers',
      friendlyName: 'Subtext',
    },
    {
      name: 'buttonText',
      type: 'string',
      required: true,
      defaultValue: 'Subscribe',
      friendlyName: 'Button Text',
    },
    {
      name: 'buttonVariant',
      type: 'string',
      required: true,
      enum: [...Object.keys(theme.buttons)],
      defaultValue: 'primary',
      friendlyName: 'Button Style',
    },
    {
      name: 'placeholderText',
      type: 'string',
      required: true,
      defaultValue: 'Enter your email address',
      friendlyName: 'Email Placeholder',
    },
    {
      name: 'pageVariant',
      type: 'string',
      required: false,
      defaultValue: '',
      friendlyName: 'Page Variant',
      helperText: 'Leave empty to auto use variant URL',
    },
    {
      name: 'apiEndpoint',
      type: 'string',
      required: false,
      defaultValue: '',
      friendlyName: 'Zapier Endpoint',
      helperText: 'Leave empty to use the brand default from region config (zapierEndpoint).',
    },
    {
      name: 'redirectUrl',
      type: 'string',
      required: false,
      defaultValue: '',
      friendlyName: 'Redirect URL (after subscribe)',
    },
  ],
});

